<div class="live-help-container">

  <!-- Error panel -->
  <div class="live-help-panel error-panel" *ngIf="errorMsg">
    <div class="error-header">
      <div class="error-icon-wrap">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <div class="error-body">

      <!-- Arabic -->
      <div class="confirm-lang ar" dir="rtl">
        <p class="error-title">مشاركة الشاشة غير مسموح بها</p>
        <p class="confirm-desc">
          لحماية بيانات المستخدمين، يُسمح <strong>فقط</strong> بمشاركة تبويب <strong>BlueRide</strong> الحالي.<br>
          يُرجى النقر على <strong>ابدأ</strong> مجدداً واتباع الخطوات التالية:
        </p>
        <ul class="confirm-steps">
          <li><span class="step-icon">1️⃣</span> ستظهر نافذة تطلب مشاركة التبويب الحالي <strong>(BlueRide)</strong></li>
          <li><span class="step-icon">2️⃣</span> انقر <strong>"مشاركة"</strong> أو <strong>"Share"</strong> للموافقة</li>
          <li><span class="step-icon">🚫</span> لا يُسمح بمشاركة تبويب آخر أو الشاشة بالكامل أو نافذة</li>
        </ul>
      </div>

      <div class="confirm-divider"></div>

      <!-- English -->
      <div class="confirm-lang en" dir="ltr">
        <p class="error-title">Screen sharing not allowed</p>
        <p class="confirm-desc">
          To protect user data, <strong>only</strong> the current <strong>BlueRide tab</strong> may be shared.<br>
          Click <strong>Start</strong> again and follow these steps:
        </p>
        <ul class="confirm-steps">
          <li><span class="step-icon">1️⃣</span> A prompt will appear asking to share the current tab <strong>(BlueRide)</strong></li>
          <li><span class="step-icon">2️⃣</span> Click <strong>"Share"</strong> to confirm</li>
          <li><span class="step-icon">🚫</span> Sharing another tab, entire screen, or window is not permitted</li>
        </ul>
      </div>
    </div>

    <div class="error-footer">
      <button class="btn-ok" (click)="dismissError()">OK / حسناً</button>
    </div>
  </div>

  <!-- Confirmation popup -->
  <div class="live-help-panel confirm-panel" *ngIf="state === 'idle' && showConfirm">
    <div class="confirm-header">
      <div class="confirm-icon-wrap">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <rect x="9" y="2" width="6" height="12" rx="3" fill="white"/>
          <path d="M5 10C5 14.418 8.134 18 12 18C15.866 18 19 14.418 19 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="12" y1="18" x2="12" y2="22" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <line x1="9" y1="22" x2="15" y2="22" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <button class="btn-close confirm-close" (click)="cancelConfirm()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
    </div>

    <div class="confirm-body">

      <!-- Arabic -->
      <div class="confirm-lang ar" dir="rtl">
        <p class="confirm-title-ar">مساعد بلورايد الذكي</p>
        <p class="confirm-desc">
          ستبدأ جلسة مباشرة مع مساعد بلورايد الذكي.<br>
          سيُطلب منك <strong>الوصول إلى الميكروفون</strong> فقط للبدء.<br>
          يمكنك <strong>مشاركة الشاشة</strong> لاحقاً عند الحاجة.
        </p>
        <ul class="confirm-steps">
          <li><span class="step-icon">🎙️</span> اسمح بالوصول إلى الميكروفون</li>
          <li><span class="step-icon">💬</span> ابدأ الحديث — المساعد يسمعك</li>
          <li><span class="step-icon">🖥️</span> شارك التبويب عند الطلب (اختياري)</li>
        </ul>
      </div>

      <div class="confirm-divider"></div>

      <!-- English -->
      <div class="confirm-lang en" dir="ltr">
        <p class="confirm-title-en">BlueRide AI Assistant</p>
        <p class="confirm-desc">
          You're about to start a live session with BlueRide's AI onboarding agent.<br>
          You'll be asked for <strong>microphone access</strong> only to start.<br>
          You can <strong>share your screen</strong> later when needed.
        </p>
        <ul class="confirm-steps">
          <li><span class="step-icon">🎙️</span> Allow microphone access</li>
          <li><span class="step-icon">💬</span> Start talking — the agent hears you</li>
          <li><span class="step-icon">🖥️</span> Share the tab later if needed (optional)</li>
        </ul>
      </div>
    </div>

    <div class="confirm-footer">
      <button class="btn-cancel" (click)="cancelConfirm()">Later / لاحقاً</button>
      <button class="btn-start" (click)="startSession()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M5 3L19 12L5 21V3Z" fill="currentColor"/>
        </svg>
        Start / ابدأ
      </button>
    </div>
  </div>

  <!-- Connecting -->
  <div class="live-help-panel" *ngIf="state === 'connecting'">
    <div class="panel-header">
      <span class="panel-title">Connecting...</span>
      <button class="btn-close" (click)="endSession()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
    </div>
    <div class="panel-body">
      <div class="spinner-ring"></div>
      <p class="panel-hint">Requesting mic &amp; screen access</p>
    </div>
  </div>

  <!-- Active call -->
  <div class="live-help-panel panel-dark" *ngIf="state === 'active'">
    <div class="panel-header-dark">
      <div class="live-badge">
        <span class="live-dot"></span>
        LIVE
      </div>
      <span class="panel-timer-dark">{{ elapsed }}</span>
      <button class="btn-close-dark" (click)="endSession()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>
      </button>
    </div>
    <div class="panel-body-dark">
      <p class="active-hint">Gemini can hear you — tap Snapshot to share what you see</p>
      <div class="audio-bars" [class.muted]="isMuted">
        <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
      </div>

      <!-- Continuous screen-share flow disabled — replaced by single-snapshot button below.
      <div class="video-countdown" *ngIf="videoEnabled" [class.warning]="videoCountdownWarning">
        <span class="video-countdown-label">Sharing · {{ videoCountdownText }}</span>
        <button *ngIf="videoCountdownWarning" class="btn-extend" (click)="extendVideo()" title="Extend 2 more minutes">
          Extend
        </button>
      </div>
      -->

      <div class="panel-actions">
        <button class="btn-mute-dark" [class.muted]="isMuted" (click)="toggleMute()" [title]="isMuted ? 'Unmute' : 'Mute'">
          <svg *ngIf="!isMuted" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect x="9" y="2" width="6" height="12" rx="3" fill="currentColor"/>
            <path d="M5 10C5 14.418 8.134 18 12 18C15.866 18 19 14.418 19 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="18" x2="12" y2="22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <svg *ngIf="isMuted" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect x="9" y="2" width="6" height="12" rx="3" fill="currentColor" opacity="0.5"/>
            <path d="M5 10C5 14.418 8.134 18 12 18C15.866 18 19 14.418 19 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" opacity="0.5"/>
            <line x1="3" y1="3" x2="21" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          {{ isMuted ? 'Unmute' : 'Mute' }}
        </button>
        <button class="btn-mute-dark" [class.snapshot-sent]="snapshotSent" [disabled]="sendingSnapshot || snapshotSent" (click)="sendSnapshot()" [title]="'Send a single screenshot'">
          <svg *ngIf="!snapshotSent" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M4 7h3l2-2h6l2 2h3a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Z" stroke="currentColor" stroke-width="2"/>
            <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2"/>
          </svg>
          <svg *ngIf="snapshotSent" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ snapshotSent ? 'Screen shared' : (sendingSnapshot ? 'Sending…' : 'Snapshot') }}
        </button>
        <!-- Continuous Share Screen button disabled — single-snapshot flow only for now.
        <button class="btn-mute-dark" [class.muted]="!videoEnabled" (click)="toggleVideo()" [title]="videoEnabled ? 'Stop sharing screen' : 'Share screen'">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="4" width="20" height="13" rx="2" stroke="currentColor" stroke-width="2"/>
            <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          {{ videoEnabled ? 'Stop Share' : 'Share Screen' }}
        </button>
        -->
        <button class="btn-end-dark" (click)="endSession()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M22 16.92V19.92C22 20.48 21.75 21.02 21.31 21.38C20.88 21.74 20.3 21.9 19.75 21.82C16.56 21.39 13.5 20.26 10.8 18.53C8.28 16.94 6.15 14.81 4.56 12.29C2.82 9.58 1.69 6.5 1.27 3.3C1.19 2.75 1.35 2.17 1.71 1.74C2.07 1.3 2.6 1.05 3.17 1.05H6.17C7.15 1.04 7.99 1.73 8.17 2.7C8.35 3.66 8.64 4.6 9.03 5.5C9.29 6.11 9.13 6.81 8.63 7.26L7.37 8.52C8.8 11.12 10.96 13.28 13.57 14.72L14.83 13.46C15.27 12.96 15.98 12.8 16.59 13.06C17.49 13.44 18.43 13.73 19.39 13.92C20.36 14.1 21.06 14.95 21.05 15.95L22 16.92Z" fill="currentColor"/>
          </svg>
          End Call
        </button>
      </div>
    </div>
  </div>

  <!-- Ending / generating summary -->
  <div class="live-help-panel" *ngIf="state === 'ending'">
    <div class="panel-header">
      <span class="panel-title">Generating summary...</span>
    </div>
    <div class="panel-body">
      <div class="spinner-ring"></div>
    </div>
  </div>

  <!-- Summary -->
  <div class="live-help-panel summary-panel" *ngIf="state === 'summary' && summary">
    <div class="panel-header">
      <span class="panel-title">Session Summary</span>
      <button class="btn-close" (click)="dismiss()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
    <div class="panel-body summary-body">

      <!-- Title -->
      <div class="summary-title-row">
        <span class="summary-title">{{ summary.title }}</span>
      </div>

      <!-- AI summary text -->
      <p class="summary-text">{{ summary.summary }}</p>

      <!-- Tags -->
      <div class="summary-tags" *ngIf="summary.tags.length">
        <span class="summary-tag" *ngFor="let tag of summary.tags">{{ tag }}</span>
      </div>

      <!-- Meta row -->
      <div class="summary-meta">
        <span>{{ formatDuration(summary.durationSeconds) }}</span>
      </div>

    </div>
  </div>

  <!-- Idle: floating button — always at the bottom -->
  <button class="live-help-fab" *ngIf="state === 'idle'" (click)="openConfirm()" title="Start Live Help">
    <span class="fab-ring r1"></span>
    <span class="fab-ring r2"></span>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="9" y="2" width="6" height="12" rx="3" fill="white"/>
      <path d="M5 10C5 14.418 8.134 18 12 18C15.866 18 19 14.418 19 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <line x1="12" y1="18" x2="12" y2="22" stroke="white" stroke-width="2" stroke-linecap="round"/>
      <line x1="9" y1="22" x2="15" y2="22" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

</div>
